import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Design 2.0 card container — white surface, 12px radius, soft border, gentle
 * shadow. Use this everywhere a Design 2.0 "card" appears so the elevation and
 * spacing stay identical across pages and tabs.
 *
 * Typical layout:
 * ```html
 * <app-v2-card>
 *   <header slot="header">…icon + title + actions…</header>
 *   <div>…body…</div>
 *   <footer slot="footer">…action buttons…</footer>
 * </app-v2-card>
 * ```
 *
 * For simple bodies, just project content directly:
 * ```html
 * <app-v2-card>…anything…</app-v2-card>
 * ```
 *
 * Inputs:
 *  - `padding` — override default 20px inner padding ("none" for flush layouts)
 *  - `tone`    — `default` (white), `info` (light blue) for the help card, or `danger`
 *                (light red) for a warning card
 */
@Component({
  selector: 'app-v2-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './v2-card.component.html',
  styleUrls: ['./v2-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V2CardComponent {
  readonly padding = input<'default' | 'compact' | 'none'>('default');
  readonly tone = input<'default' | 'info' | 'danger'>('default');
}
